import { render, staticRenderFns } from "./TabPanel.vue?vue&type=template&id=c053c79e&scoped=true"
import script from "./TabPanel.vue?vue&type=script&lang=js"
export * from "./TabPanel.vue?vue&type=script&lang=js"
import style0 from "./TabPanel.vue?vue&type=style&index=0&id=c053c79e&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c053c79e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\web\\medical\\medical-student\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c053c79e')) {
      api.createRecord('c053c79e', component.options)
    } else {
      api.reload('c053c79e', component.options)
    }
    module.hot.accept("./TabPanel.vue?vue&type=template&id=c053c79e&scoped=true", function () {
      api.rerender('c053c79e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/screeningConfig/physicalConfig/physicalProject/TabPanel.vue"
export default component.exports